import React, { Component } from 'react'

import '../scss/Aroura.scss'

export default class Aroura extends Component {
  render() {
    return (
    <div className="bg">
        <div className="aur_cont">
          <span className="aur aur_1"></span>
          <span className="aur aur_2"></span>
          <span className="aur aur_3"></span>
          <span className="aur aur_4"></span>
          <span className="aur aur_5"></span>
          <span className="aur aur_6"></span>
          <span className="aur aur_7"></span>
          <span className="aur aur_8"></span>
          <span className="aur aur_9"></span>
          <span className="aur aur_10"></span>
          <span className="aur aur_11"></span>
          <span className="aur aur_12"></span>
          <span className="aur aur_13"></span>
          <span className="aur aur_14"></span>
          <span className="aur aur_15"></span>
          <span className="aur aur_16"></span>
          <span className="aur aur_17"></span>
          <span className="aur aur_18"></span>
          <span className="aur aur_19"></span>
          <span className="aur aur_20"></span>
          <span className="aur aur_21"></span>
          <span className="aur aur_22"></span>
          <span className="aur aur_23"></span>
          <span className="aur aur_24"></span>
        </div>
      </div>
    )
  }
}
